<div class="card">
  <div class="card" style="display: flex; justify-content: space-between; align-items: center; padding: 0; border: none; background-color: transparent;">
    <div>
        <h4><strong style=" margin-left: 10px;">Reconciliation List</strong></h4>
    </div>
    <div style="display: flex; margin-top: -10px;">
        <button pButton type="button" icon="pi pi-download" (click)="downloadExcel()" style=" background-color: #2c436b;" label="Excel Report"></button>
    </div>
</div>
  <div class="grid">
    <div class="col">

    </div>
    <!-- <div class="col">
      <label for="startDate">Start Date:</label>
      <input pInputText type="date" [(ngModel)]="startDate" (change)="filterByDateRange()">
    </div>
    <div class="col">
      <label for="endDate">End Date:</label>
    <input pInputText type="date" [(ngModel)]="endDate" (change)="filterByDateRange()">
    </div> -->
    <div class="col">
      <label class="font-bold block mb-2">Start Date</label>
      <p-calendar [(ngModel)]="startDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="filterByDateRange()" />
  </div>
 <div class="col">
      <label class="font-bold block mb-2">End Date</label>
      <p-calendar [(ngModel)]="endDate" [showButtonBar]="true" dateFormat="dd/mm/yy" (onSelect)="filterByDateRange()"/>
 </div>
    <div class="col">

    </div>
  </div>
  <hr>
  <p-table [columns]="cols"  #tt [value]="getReconciliationsList" class="table-bordered"  >
      <ng-template pTemplate="header" let-columns>
          <tr >
              <th *ngFor="let col of columns">
                  {{ col.header }}
              </th>
          </tr>
          <tr>
            <th *ngFor="let col of cols">
              <ng-container *ngIf="col.field === 'post_date' || col.field === 'bill_date'; else textInput">
                <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
              </ng-container>
              <ng-template #textInput>
                <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
              </ng-template>
                <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" /> -->
            </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns">
              <!-- Check if the field is 'posting_date' and format it accordingly -->
              <span *ngIf="col.field === 'post_date' || col.field === 'bill_date'; else defaultField">
                {{ rowData[col.field] | date: 'dd.MM.yyyy' }}
              </span>
              <ng-template #defaultField>
                  {{ rowData[col.field] }}
              </ng-template>
          </td>
          </tr>
      </ng-template>
      <ng-template pTemplate="footer" let-columns>
        <tr>
          <td *ngFor="let col of columns">
            <ng-container *ngIf="col.field === 'ty'">Total</ng-container>
            <ng-container *ngIf="col.field === 'debit'">{{ totalDebit }}</ng-container>
            <ng-container *ngIf="col.field === 'credit'">{{ totalCredit }}</ng-container>
            <ng-container *ngIf="col.field === 'balance'">{{ totalBalance }}</ng-container>
          </td>
        </tr>
      </ng-template>
  </p-table>
  <div>
    <p-paginator
        [rows]="limit"
        [first]="(currentPage - 1) * limit"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[10, 20,30,50,100]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
   />
</div>
</div>
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
